import { render, staticRenderFns } from "./city-popover.vue?vue&type=template&id=dd523562&scoped=true"
import script from "./city-popover.vue?vue&type=script&lang=js"
export * from "./city-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd523562",
  null
  
)

export default component.exports